export enum RuleNodeType {
    AND = 'and',
    OR = 'or',
}
